<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <div class="search-filters">
        <b-form-group :label="$t('searchworkerid')">
          <b-form-input
            v-model="search.empid"
            class="search-input"
            :placeholder="$t('workerid')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchUser')">
          <b-form-input
            v-model="search.name"
            class="search-input"
            :placeholder="$t('user')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchEmail')">
          <b-form-input
            v-model="search.email"
            class="search-input"
            :placeholder="$t('emailname')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchdept')">
          <b-form-input
            v-model="search.dept"
            class="search-input"
            :placeholder="$t('deptname')"
          />
        </b-form-group>
        <b-form-group :label="$t('searchrole')">
          <b-form-input
            v-model="search.role"
            class="search-input1"
            :placeholder="$t('uppersearchrole')"
          />
        </b-form-group>
        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchEmp(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>
      </div>

      <div class="table-wrapper">
        <div v-if="isAdmin">
          <b-table
            :items="employees"
            :fields="fields"
            class="employee-table"
          >
            <template #cell(empid)="data">
              <div class="multiline-text">
                {{ data.item.empid }}
              </div>
            </template>
            <template #cell(image)="data">
              <img
                v-if="data.item.imageUrl"
                :src="data.item.imageUrl"
                alt="Employee Image"
                class="employee-image"
              >
              <div
                v-else
                class="employee-image"
              >
                <b-icon
                  icon="person"
                  aria-hidden="true"
                  class="large-icon"
                />
              </div>
            </template>
            <template #cell(username)="data">
              <div class="multiline-text">
                {{ data.item.username }}
              </div>
            </template>
            <template #cell(email)="data">
              <div class="multiline-text">
                {{ data.item.email }}
              </div>
            </template>
            <template #cell(phone)="data">
              <div class="multiline-text">
                {{ data.item.phone }}
              </div>
            </template>
            <template #cell(dept)="data">
              <div class="multiline-text">
                {{ data.item.dept }}
              </div>
            </template>
            <template #cell(jobtitle)="data">
              <div class="multiline-text">
                {{ data.item.jobtitle.titleName }}
              </div>
            </template>
            <template #cell(signature)="data">
              <img
                v-if="data.item.signature"
                :src="data.item.signature"
                alt="Signature"
                class="employee-signature"
              >
              <div
                v-else
                class="multiline-text"
              >
                {{ $t('nosignature') }}
              </div>
            </template>
            <template #cell(roles)="data">
              <div class="multiline-text">
                <span
                  v-for="role in data.item.roles"
                  :key="role.id"
                >{{ role.name }}<br></span>
              </div>
            </template>
            <template #cell(status)="data">
              {{ data.item.isEnabled ? $t('active') : $t('nonactive') }}
            </template>
          </b-table>

          <div
            v-if="!isLoading && totalEmp === 0"
            class="text-center mt-3"
          >
            <p style="font-size: 28px; font-weight: bold;">
              {{ $t('nonuser') }}
            </p>
          </div>

        </div>
      </div>
      <div
        v-if="!isLoading && totalEmp > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalEmp"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>

      <EmployeeModal
        :show="employeeModal"
        :employee="selectedEmployee"
        @close="employeeModal = false"
      />

      <b-modal
        id="add-user-modal"
        v-model="showModal"
        :title="$t('adduser')"
        hide-footer
        @hide="closeModal"
      >
        <RegisterForm
          :employee="selectedEmployee"
          @close="closeModal"
          @data-added="initialize"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import { getRolesFromToken } from '@/services/JwtDecoder'
import apiSetting from '@/services/Setting'
import apiAuth from '@/services/auth'
import RegisterForm from './Regsiter_Setting.vue'
import EmployeeModal from './EmployeeModal.vue'

export default {
  components: {
    RegisterForm,
    EmployeeModal,
  },
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      employees: [],
      roles: [],
      isAdmin: false,
      search: {
        empid: '', name: '', email: '', dept: '', role: '',
      },
      activeFilter: '',
      showModal: false,
      employeeModal: false,
      isLoading: true,
      totalEmp: 0,
      totalPages: 0,
      currentPage: 1,
      itemsPerPage: 5,
      selectedEmployee: {},
    }
  },
  computed: {
    fields() {
      return [
        { key: 'empid', label: this.$t('workerid'), sortable: true },
        { key: 'image', label: this.$t('image'), sortable: true },
        { key: 'username', label: this.$t('user'), sortable: true },
        { key: 'email', label: this.$t('email'), sortable: true },
        { key: 'phone', label: this.$t('phone'), sortable: true },
        { key: 'dept', label: this.$t('deptname'), sortable: true },
        { key: 'jobtitle', label: this.$t('jobtitle'), sortable: true },
        { key: 'roles', label: this.$t('role'), sortable: true },
        { key: 'status', label: this.$t('status'), sortable: true },
      ]
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    async initialize() {
      await this.fetchUserRole()
      await this.fetchEmployees()
    },
    showAddUserModal() {
      this.selectedEmployee = null
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedEmployee = {}
    },
    showEditModal(employee) {
      if (this.isAdmin) {
        this.selectedEmployee = { ...employee }
        this.showModal = true
      } else {
        alert('Access Denied')
      }
    },
    viewDetails(employee) {
      this.selectedEmployee = { ...employee }
      console.log('Selected Employee:', this.selectedEmployee)
      this.employeeModal = true
    },

    async searchEmp(page = 1) {
      this.isLoading = true
      try {
        if (!this.search.empid && !this.search.name && !this.search.email && !this.search.dept && !this.search.role) {
          await this.fetchEmployees(page)
          return // หยุดการทำงานของฟังก์ชัน
        }
        this.currentPage = page
        const params = {
          empid: this.search.empid || null,
          name: this.search.name || null,
          email: this.search.email || null,
          dept: this.search.dept || null,
          role: this.search.role || null,
          page: page - 1,
          size: this.itemsPerPage,
        }

        let response

        if (this.roles && (this.roles.includes('ADMIN') || this.roles.includes('SYSTEM'))) {
          response = await apiAuth.get('auth/showdataList/search', { params })
        } else {
          console.log("ERROR: Your Role can't Access ")
          return
        }

        if (response) {
          this.employees = await Promise.all(response.data.content.map(async employee => {
            let imageUrl = null
            let signatureUrl = null

            // ส่วนการดึงรูปภาพ
            if (employee.profileImage) {
              try {
                const imageResponse = await apiSetting.get(`/profileImage/${employee.id}`, { responseType: 'arraybuffer' })
                imageUrl = `data:image/jpeg;base64,${Buffer.from(imageResponse.data, 'binary').toString('base64')}`
              } catch (imageError) {
                console.error('Error fetching image for employee id:', employee.id, imageError)
              }
            }

            // ส่วนการดึงลายเซ็น
            if (employee.signature) {
              try {
                const signatureResponse = await apiSetting.get(`/signature/${employee.id}`, { responseType: 'arraybuffer' })
                signatureUrl = `data:image/jpeg;base64,${Buffer.from(signatureResponse.data, 'binary').toString('base64')}`
              } catch (signatureError) {
                console.error('Error fetching signature for employee id:', employee.id, signatureError)
              }
            }

            return {
              ...employee,
              isEnabled: employee.enabled,
              dept: employee.dept ? employee.dept.dept : '', // แสดงชื่อแผนก
              roles: employee.roles,
              imageUrl,
              signature: signatureUrl,
            }
          }))

          this.totalEmp = response.data.totalElements // อัปเดตจำนวนพนักงาน
          this.totalPages = response.data.totalPages
          // หากค้นหาแล้วไม่มีข้อมูล
          if (this.totalEmp === 0) {
            this.errorMessage = 'ไม่พบข้อมูลที่ค้นหา'
          } else {
            this.errorMessage = ''
          }
        }
      } catch (error) {
        console.error('Error fetching employees:', error)
        this.employees = []
        this.totalEmp = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
      }
    },

    async fetchUserRole() {
      const role = getRolesFromToken(localStorage.getItem('accessToken'))
      this.roles = role
      this.isAdmin = role.includes('ADMIN') || role.includes('SYSTEM')
    },
    async fetchEmployees() {
      this.isLoading = true
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.itemsPerPage,
        }
        const response = await apiAuth.get('auth/showdataList', { params })
        console.log('API Response:', response.data.content)

        this.employees = await Promise.all(response.data.content.map(async employee => {
          let imageUrl = null
          let signatureUrl = null

          if (employee.profileImage) {
            try {
              const imageResponse = await apiSetting.get(`/profileImage/${employee.id}`, { responseType: 'arraybuffer' })
              imageUrl = `data:image/jpeg;base64,${Buffer.from(imageResponse.data, 'binary').toString('base64')}`
            } catch (imageError) {
              console.error('Error fetching image for employee id:', employee.id, imageError)
            }
          }

          if (employee.signature) {
            try {
              const signatureResponse = await apiSetting.get(`/signature/${employee.id}`, { responseType: 'arraybuffer' })
              signatureUrl = `data:image/jpeg;base64,${Buffer.from(signatureResponse.data, 'binary').toString('base64')}`
            } catch (signatureError) {
              console.error('Error fetching signature for employee id:', employee.id, signatureError)
            }
          }

          return {
            ...employee,
            isEnabled: employee.enabled,
            dept: employee.dept ? employee.dept.dept : '',
            roles: employee.roles,
            imageUrl,
            signature: signatureUrl,
          }
        }))

        this.totalEmp = response.data.totalElements
        this.totalPages = response.data.totalPages
        console.log('Fetched new employee data')
      } catch (error) {
        console.error('Error fetching employees:', error.response ? error.response.data.content : error.message)
      } finally {
        this.isLoading = false
      }
    },
    async handlePageChange(page) {
      this.currentPage = page // ตั้งค่า currentPage ใหม่
      await this.searchEmp(this.currentPage)
    },
  },
}
</script>

<style scoped>
.listdata {
  font-size: small;
  margin: 0.5%;
}

.container {
  display: flex;
  flex-direction: column; /* จัดเรียงให้อยู่ในแนวตั้ง */
  gap: 20px; /* กำหนดระยะห่างระหว่างแต่ละองค์ประกอบ */
  align-items: flex-start; /* จัดให้อยู่ติดขอบซ้าย */
}

.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.employee-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.employee-signature {
  width: 100px; /* ปรับขนาดตามที่ต้องการ */
  height: auto;
}

.multiline-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: small;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.search-input {
  width: 200px;
}

.search-input1 {
  width: 200px;
}

.large-icon {
  font-size: 50px;
}

.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}
.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.employee-table thead {
    display: none; /* ซ่อนหัวตาราง */
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  white-space: nowrap;
}

.employee-table {
  width: 100%; /* ให้ตารางเต็มความกว้าง */
  border-collapse: collapse;
}

@media (max-width: 768px) {
  .employee-table {
    display: block; /* เปลี่ยนตารางให้เป็น block */
    overflow-x: auto; /* เพิ่มแถบเลื่อนแนวนอน */
  }
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
